import React from 'react'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import PrimaryButton from 'shared/components/primary-button'

interface UnsubscribeCardProps {
  children: JSX.Element
  onConfirmUnsubscribe: () => void
  isFetching?: boolean
  isSuccess: boolean
  title?: string
}

function UnsubscribeCard({
  children,
  onConfirmUnsubscribe,
  isFetching,
  isSuccess,
}: UnsubscribeCardProps) {
  const { t } = useTranslation()

  return (
    <>
      <Image
        src={`${
          isSuccess ? '/images/unsubscription-confirm-page.png' : '/images/unsubscribed.png'
        }`}
        alt={t('unsubscribe_page.unsubscribe.title')}
        height={149}
        width={180}
      />
      <>
        <h1 className="mb-8">{t('unsubscribe_page.unsubscribe.title')}</h1>
        {children}
        <div className="flex w-full justify-center gap-4">
          <PrimaryButton
            width="large"
            className="w-full text-base"
            isLoading={isFetching}
            onClick={async e => {
              e.preventDefault()
              await onConfirmUnsubscribe()
            }}
            type="submit"
          >
            {t('unsubscribe_page.unsubscribe.confirm')}
          </PrimaryButton>
        </div>
      </>
    </>
  )
}

export default UnsubscribeCard
